import sc from 'styled-components';

import {Layout} from '@phonectas/unifon-ui-kit';

interface StyledEventLayoutProps {
	activeTab: string;
}

export const StyledEventLayout = sc(Layout).withConfig({
	shouldForwardProp: (prop) => prop !== 'activeTab',
})<StyledEventLayoutProps>`
	height: ${({activeTab}) => (activeTab === '1' ? '100%' : 'auto')};
	width: 100%;
	overflow: hidden;
`;

export const StyledTabsLayout = sc(Layout)`
	display: flex;
`;
